export default __webpack_public_path__ + "static/media/SensorPelvisRight.5ea96445.svg";